import { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { useEnv } from '@/hooks/useEnv'
import VAxios from './axios'
import { token, removeToken, insideIframe } from '@/utils'
import { h } from 'vue'
import { message } from 'ant-design-vue'
import qs from 'qs'
// import { AxiosCanceler } from './cancel'
import type { AXIOS } from '@/types/types'
import router from '@/router'
import useCertificateModal from '@/hooks/useCertificateModal'

const { VITE_APP_BASE_API, VITE_APP_YUN_API, VITE_APP_YUN_SAVE_API, VITE_APP_COMMUNITY_API } =
  useEnv()
const { showCertificate } = useCertificateModal()
const DEFAULT_SUCCESS = '操作成功'
// const axiosCanceler = new AxiosCanceler()

const setInterceptor = (otherConfig?: any) => {
  const interceptor = {
    beforeRequest(config: any): void {
      config.headers = {
        ...(config.headers || {}),
        ...otherConfig,
        jweToken: token(),
      }
    },

    requestInterceptors(config: AxiosRequestConfig) {
      // axiosCanceler.addPending(config)
      return config
    },

    responseInterceptors(
      response: AxiosResponse & { config: AXIOS.CreateAxiosOptions },
    ): Promise<AxiosResponse<unknown>> {
      // const { config } = response
      // axiosCanceler.removePending(config)
      if (response.config.requestOptions?.isMsg) message.success(DEFAULT_SUCCESS)
      return Promise.resolve(response)
    },

    responseInterceptorsStatusCatch({
      code,
      message: msg,
      error,
    }: {
      code: number
      message: string
      error: string
    }) {
      switch (code) {
        case 40311001:
          showCertificate()
          // Modal.confirm({
          //   title: '请先完成个人/企业实名认证',
          //   icon: false,
          //   okText: '前往认证',
          //   onOk() {
          //     // 保存当前页面 认证成功后回跳
          //     const url = JSON.parse(JSON.stringify(router.currentRoute.value.fullPath || ''))
          //     usePayUrl().setUrl(url)
          //     router.push(`${PATH.ACCOUNT}?tab=checkInfo`)
          //   },
          // })
          break
        case 40016010:
          break
        case 40016900:
          break
        case 40016901:
          break
        case 40011007:
          message.error(
            h('span', {}, [
              '存在未支付的订单，不允许创建新订单',
              h('a', { href: 'https://portal.huixingyun.com/console/cost/bill' }, ' 详情'),
            ]),
          )
          break
        default:
          message.error(`${msg}${error ? `：${error}` : ''}`)
      }
    },

    responseInterceptorsCatch(error: AxiosError) {
      if (import.meta.env.SSR) return Promise.reject(error)
      if (error.response) {
        const data = error.response.data as { message: string; error: string; code: number }
        switch (error.response.status) {
          case 401:
            message.error(data?.message)
            removeToken()
            // iframe 判断
            if (insideIframe()) {
              window.parent.postMessage(JSON.stringify({ eventName: 'redirect_login' }), '*')
            } else {
              // 跳入首页 登录
              router.replace('/login')
            }
            break
          case 500:
          case 502:
            message.error('服务器开了个小差，请稍后重试')
            break
          default:
            interceptor.responseInterceptorsStatusCatch(data)
        }
      }

      return Promise.reject(error)
    },
  }
  return interceptor
}

const createAxios = () => {
  const baseUrl = VITE_APP_BASE_API
  const jweToken = token()
  return new VAxios({
    timeout: 30000,
    baseURL: baseUrl,
    interceptor: setInterceptor({
      jweToken,
    }),
    requestOptions: {
      isIgnoreCancelToken: false,
    },
  })
}

// 云存储
export const uploadAxios = () => {
  const baseUrl = VITE_APP_YUN_API
  return new VAxios({
    timeout: 10000000,
    baseURL: baseUrl,
    withCredentials: false, //跨域问题设置
    // interceptor: setInterceptor(config),
    requestOptions: {
      isIgnoreCancelToken: false,
    },
  })
}
export const readFileAxios = () => {
  const baseUrl = VITE_APP_YUN_SAVE_API
  return new VAxios({
    timeout: 3000,
    baseURL: baseUrl,
    withCredentials: false, //跨域问题设置
  })
}
export const communityAxios = () => {
  const baseUrl = VITE_APP_COMMUNITY_API
  const jweToken = token()
  return new VAxios({
    timeout: 3000,
    baseURL: baseUrl,
    paramsSerializer: (params: any) =>
      qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    interceptor: setInterceptor({
      jweToken,
    }),
    withCredentials: false, //跨域问题设置
  })
}

export default createAxios()
